<!--
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2023-10-25 10:03:14
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-01-26 11:56:23
 * @FilePath: /visaai-platform/src/views/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <el-header height="70">
      <page-header v-if="!headerpage"></page-header>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageHeader from '@/components/PageHeader'
import { cleanNonFreeLoginSessionIdInUrl } from '@/utils/util'
export default {
  name: 'app',
  data() {
    return {
      headerpage: window.location.href.includes('online')
    }
  },
  components: {
    PageHeader
  },
  mounted() {
    // 先同步 cookie/sessionId，再请求接口，最后清掉地址栏 sessionId（非免登）
    this.setUserInfo()
    this.setBalance()
    this.$nextTick(() => {
      cleanNonFreeLoginSessionIdInUrl()
    })
  },
  methods: {
    ...mapActions(['setUserInfo', 'setBalance'])
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1260px;
  height: 100vh;
}
</style>
